<template>
  <iframe
    width="100%"
    height="450px"
    frameBorder="0"
    src="https://docs.google.com/document/d/e/2PACX-1vTNje2RtdhWWTZEoaL69z9nxZYNs7C2NaWZebh5DAbJ27yJttXaalNqhNr8JRagf6pATTgSesmd4K5e/pub?embedded=true"
  ></iframe>
</template>

<script>
export default {
  name: "AgreementText",
};
</script>

<style scoped></style>
